module.exports = __webpack_public_path__ + "static/media/prepaid_recharge_2.a28460f0.svg";